/**
 * Fix for Okendo reviews carousel ARIA role issue
 * Changes role="group" on section elements to a valid ARIA role
 */
const OKENDO_MAX_ATTEMPTS = 15;
let okendoAttemptCount = 0;

function fixOkendoAriaRoles() {
  // Check if we've reached the maximum attempts
  if (okendoAttemptCount >= OKENDO_MAX_ATTEMPTS) {
    return false;
  }
  
  // Find all section elements with role="group" (Okendo carousel issue)
  const invalidSections = document.querySelectorAll('section.oke-reviewCarousel-reviews[role="group"]');
  
  if (invalidSections.length > 0) {
    invalidSections.forEach(section => {
      // Remove the invalid role attribute
      section.removeAttribute('role');
      
      // Find if there's a heading element we can associate with
      const nearbyHeading = section.closest('.shopify-section')?.querySelector('h2, h3');
      if (nearbyHeading && nearbyHeading.id) {
        // If heading has an ID, use it
        section.setAttribute('aria-labelledby', nearbyHeading.id);
      } else if (nearbyHeading) {
        // If heading doesn't have an ID, create one
        const headingId = 'okendo-heading-' + Math.random().toString(36).substring(2, 9);
        nearbyHeading.id = headingId;
        section.setAttribute('aria-labelledby', headingId);
      }
    });
    
    // Increment attempt count only when we find and fix elements
    okendoAttemptCount++;
    return true;
  }
  
  return false;
}

// Debounce function to limit how often the fix runs
function debounce(func, wait) {
  let timeout;
  return function() {
    clearTimeout(timeout);
    timeout = setTimeout(func, wait);
  };
}

// Debounced version of our fix function
const debouncedFix = debounce(() => {
  const fixResult = fixOkendoAriaRoles();
  
  // If we've reached max attempts or no elements were fixed, disconnect observer
  if (!fixResult && okendoAttemptCount >= OKENDO_MAX_ATTEMPTS) {
    okendoObserver.disconnect();
  }
}, 100);

// Run the fix when the DOM is ready
document.addEventListener('DOMContentLoaded', debouncedFix);

// Also run after any potential AJAX updates
document.addEventListener('page:loaded', debouncedFix);

// Set up a MutationObserver with optimized filtering
const okendoObserver = new MutationObserver(mutations => {
  // Check if we've already hit the limit
  if (okendoAttemptCount >= OKENDO_MAX_ATTEMPTS) {
    okendoObserver.disconnect();
    return;
  }
  
  // Quick check if any mutation might contain our target
  let shouldCheck = false;
  
  for (const mutation of mutations) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      // Look for HTML that might contain our target
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && 
            (node.tagName === 'SECTION' || 
             node.innerHTML?.includes('oke-reviewCarousel'))) {
          shouldCheck = true;
          break;
        }
      }
      if (shouldCheck) break;
    }
  }
  
  // Only run the fix if we found potential matches
  if (shouldCheck) {
    debouncedFix();
  }
});

// Start observing the document body for changes
okendoObserver.observe(document.body, {
  childList: true,
  subtree: true
});

